import firebase from 'firebase'
import store from './store.js'
import config from './config.js'
const firebaseConfig = {
  apiKey: 'AIzaSyCsH3gpVFsYPiImzdLmrTRTaBnrqq8teDk',
  authDomain: 'tpfla-v3.firebaseapp.com',
  databaseURL: 'https://tpfla-v3.firebaseio.com',
  projectId: 'tpfla-v3',
  storageBucket: 'tpfla-v3.appspot.com',
  messagingSenderId: '272443276118',
  appId: '1:272443276118:web:e6198d0838fbf81d6374f7'
}
// Export methods which will be used to access the firebase api
export let initializationComplete = false
export let dataLoaded = false
// initalize firebase
export const init = function () {
  if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig)
  }

  firebase.auth().onAuthStateChanged(() => {
    initializationComplete = true
  })
}
// Register method
export async function register (email, password, username) {
  // create user using the email and password
  const response = await firebase.auth().createUserWithEmailAndPassword(email, password)
  // update the user to add his username
  await response.user.updateProfile({
    displayName: username
  })
  firebase.database().ref('/users/' + response.user.uid + '/progress/').set(config.initialProgress)
  return response.user
}
// Login user
export async function login (email, password) {
  // log in using email and password
  const response = await firebase.auth().signInWithEmailAndPassword(email, password)
  // return the currently logged in user.
  return response.user
}
// Log user out
export async function logout () {
  var uid = firebase.auth().currentUser.uid
  await firebase.database().ref('/users/' + uid + '/progress').off()
  await firebase.database().ref('/users/' + uid + '/locations').off()
  console.log('watchoff')
  await firebase.auth().signOut()
  store.commit('setUser', false)
  store.commit('setProgress', config.initialProgress)
}
export function getLoggedInUser () {
  // resolve with the currently authenticated user.
  return new Promise((resolve, reject) => {
    const initializationInterval = setInterval(() => {
      if (initializationComplete) {
        clearInterval(initializationInterval)
        var connectedRef = firebase.database().ref('.info/connected')
        connectedRef.on('value', function (snap) {
          if (snap.val() === true) {
            console.log('connected')
          } else {
            console.log('not connected')
          }
        })
        resolve(firebase.auth().currentUser)
      }
    },
    10)
  })
}
export function watchUserData () {
  var uid = ''
  if (firebase.auth().currentUser) {
    uid = firebase.auth().currentUser.uid
    firebase.database().ref('/users/' + uid + '/progress').once('value').then(progSnap => {
      store.commit('setProgress', progSnap.val())
      firebase.database().ref('/users/' + uid + '/locations').once('value').then(locSnap => {
        store.commit('setLocation', locSnap.val())
        store.commit('setUser', firebase.auth().currentUser)
        dataLoaded = true
      })
    })
    firebase.database().ref('/users/' + uid + '/progress').on('value', function (snap) {
      store.commit('setProgress', snap.val())
    })
    firebase.database().ref('/users/' + uid + '/locations').on('value', function (snap) {
      store.commit('setLocation', snap.val())
    })
    console.log('watchset')
  }
}
export function getProgress (uid) {
  return new Promise((resolve, reject) => {
    resolve(firebase.database().ref('/users/' + uid + '/progress').once('value').then(function (snap) { return snap.val() }))
  })
}
export function updateProgress (newP) {
  var uid = firebase.auth().currentUser.uid
  firebase.database().ref('/users/' + uid + '/progress').update(newP)
}
export async function passwordReset (email) {
  var auth = firebase.auth()
  var emailAddress = email
  const response = await auth.sendPasswordResetEmail(emailAddress)
  return response
}
